module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-blue-bb2a1cdd.png";